/**
 * Sits atop Google Maps DrawingManager 
 * 
 * @param map
 * @param callback a function that takes a JSON representation of polygon drawn on the board.
 * @returns
 */
export class DrawingBoard {
  constructor (map, callback, google) {
    this.map = map
    this.callback = callback
    this.google = google

    /**
      * A google Maps Polygon.
    */
    this.polygon = null

    /**
      * A standard style for drawings.
    */
    this.style = {
      strokeColor: "#9d2f2f",
      strokeWeight: 1,
      fillColor: "#f8f8f8",
      fillOpacity: .5
    }

    /**
     * A Google Maps DrawingManager.
     */
    this.drawingManager = new google.maps.drawing.DrawingManager({
      drawingControl: true,
      drawingControlOptions: {
      position: google.maps.ControlPosition.TOP_CENTER,
      drawingModes: [google.maps.drawing.OverlayType.POLYGON]      
      },
      polygonOptions: this.style,
    })

    /**
     * Drawing manager event listener to anchor a new polygon to the map.
     */
    this.google.maps.event.addListener(this.drawingManager, "polygoncomplete", (poly) => {
      this.anchorNewPolygon(poly)
    })

  }

  /**
   * Exported function to clear the current polygon from the map.
   */
  clear () {
    if(this.polygon != null) {
      this.polygon.setMap(null)
      this.polygon = null
    }    
  }

  /**
   * Exported function to show the drawing controls.
   */
  showTools () {
    this.drawingManager.setMap(this.map)
  }
  /**
   * Exported function to draw the polygon described in path.
   *  
   * @path Unparsed JSON string. 
   */
   draw (path) {
    this.polygon = this.drawPolygon(JSON.parse(path))
    this.addPolygonListeners()
  }

  /**
   * Exported function to edit the current polygon.
   */
  edit () {
    this.polygon.setEditable(true)
    this.polygon.setDraggable(true)
  }

  /**
   * Exported function to lock the current polygon.
   */
  lock () {
    this.polygon.setEditable(false)
    this.polygon.setDraggable(false)
  }
      
  /**
   * Hides the drawing controls on the map.
   */
  hideTools () {
    this.drawingManager.setMap(null)
  }

  /**
   * Draws a polygon of the path specified on the map, using the default drawing style.
   */
  drawPolygon (path) {
    return new this.google.maps.Polygon({
      map: this.map,
      paths: path,
      strokeColor: this.style.strokeColor,
      strokeWeight: this.style.strokeWeight,
      fillColor: this.style.fillColor,
      fillOpacity: this.style.fillOpacity
    })
  }

  /**
   * Anchors a newly drawn polygon to the map and calls the callback method for the first time.
   * 
   * @param poly
   */
   anchorNewPolygon (poly) {
    this.polygon = poly
    this.callback(JSON.stringify(this.polygon.getPath().getArray()))
    this.hideTools()
    this.addPolygonListeners()
  } 

  /**
   * Adds event listeners to call the callback method when a polygon is modified.
   */
  addPolygonListeners() {
    this.google.maps.event.addListener(this.polygon.getPath(), 'insert_at', () => {
      this.callback(JSON.stringify(this.polygon.getPath().getArray()))
    })
    
    this.google.maps.event.addListener(this.polygon.getPath(), 'set_at', () => {
      this.callback(JSON.stringify(this.polygon.getPath().getArray()))
    })
  }
}